import {apiUrl} from "../../components/common/getEnv";

export const modelQueryUrl = (brandId, categoryId) => `${apiUrl}/models?q=&brand_id=${brandId}&category_id=${categoryId}`;